export default __webpack_public_path__ + "static/media/send-circle.757112df.svg";